import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { MessageService } from '../services/message.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard  {

  constructor(private userservice: UserService, private messageService: MessageService, public router: Router, public http: HttpClient) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get('/Users/Authed').toPromise().then((res: any) => {
        switch (res?.Authed) {// there can only be one role
          case "True":
            return true;
          default:
            this.messageService.emitChange({ "Css": "error", "Message": "Auth Oops... access denied..." });
            this.router.navigate(['/denied']);
            return true;
        }
    });  
  }



}

